import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';

/**
 * Palette et formatage de la MissionCard. Deux surfaces, deux habillages :
 * Relations vit dans le Hub (tokens `--rh-*`), Travail dans une page neutre. Le
 * vocabulaire et la structure, eux, sont identiques — seules les couleurs varient.
 *
 * Fichier sans composant (règle react-refresh : un .tsx n'exporte que des composants).
 */

export type MissionVariant = 'relations' | 'travail';

export function cardChrome(variant: MissionVariant, waits: boolean): string {
  if (waits) {
    // L'attente prime sur la palette de surface : c'est le seul état où Otto est
    // bloqué sur Gilles, il doit se voir de la même façon partout.
    return 'border-amber-200 bg-amber-50/60 dark:border-amber-900 dark:bg-amber-950/20';
  }
  return variant === 'relations'
    ? 'border-[var(--rh-ai-weak)] bg-[var(--rh-ai-weak)]'
    : 'border-neutral-200 bg-white dark:border-neutral-800 dark:bg-neutral-950';
}

export function accentText(variant: MissionVariant): string {
  return variant === 'relations' ? 'text-[var(--rh-ai)]' : 'text-neutral-500 dark:text-neutral-400';
}

/** Date relative en français ("dans 13 jours"), ou null si non planifié/illisible. */
export function relativeWhen(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return formatDistanceToNow(date, { addSuffix: true, locale: fr });
}
